import type { FinEnvironmentName, IFinEnvironment } from './environment-types';

export const environment: IFinEnvironment = {
  name: 'urbio' as FinEnvironmentName,
  production: true,
  isSaaSProject: false,
  api: {
    gatewayWSUrl: 'wss://gateway.services.dynd.urbio-romania.ro/graphql',
    gatewayUrl: 'https://gateway.services.dynd.urbio-romania.ro/graphql',
    SSOUrl: 'https://sso.services.dynd.urbio-romania.ro',
    currenciesUrl: 'https://gateway.services.dynd.urbio-romania.ro/utils/currency-config',
    userDocumentsUrl: 'https://sso.services.dynd.urbio-romania.ro/utils/document-signs',
    fileServerUrl: 'https://fileuploader.services.dynd.urbio-romania.ro/files',
    instrumentsUploadTemplateUrl:
      'https://urbio-config-files.s3.eu-central-1.amazonaws.com/public-assets/xslx-templates/bulk_instrument_upload.xlsx',
    customersBulkUploadTemplateUrl:
      'https://urbio-config-files.s3.eu-central-1.amazonaws.com/public-assets/xslx-templates/bulk_customer_upload_template.xlsx',
    leadsBulkUploadTemplateUrl:
      'https://urbio-config-files.s3.eu-central-1.amazonaws.com/public-assets/xslx-templates/bulk_customer_upload_template.xlsx',
    uploadingLeadsForSelfOnboardingTemplateUrl:
      'https://urbio-config-files.s3.eu-central-1.amazonaws.com/public-assets/xslx-templates/self_onboarding_upload_template.xlsx',
    integrationDocumentationUrl: 'https://gateway.services.dynd.urbio-romania.ro/v1/api/integration-docs',
    fullAPIReferenceUrl: 'https://gateway.services.dynd.urbio-romania.ro/v1/api/docs',
    rateLimiterHeader: '',
    maxUserInactivityMinutes: 60,
  },
  platform: {
    title: 'Urbio Romania Platform',
    company: 'Urbio Romania',
    displayUrl: 'dynd.urbio-romania.ro',
    companyAddress: 'Muzicescu nr. 6 Iasi, Iasi, 700127',
    logo: {
      default: { src: 'assets/logo/logo.svg', width: 102, height: 44 },
      login: { src: 'assets/logo/logo-login.svg', width: 162, height: 72 },
      collapsedSidebar: { src: 'assets/logo/logo-sidebar-collapsed.svg', width: 50, height: 20 },
    },
    faviconUrl: 'assets/favicon/favicon.ico',
    email: 'support@dynd.urbio-romania.ro',
    validators: [
      { rule: 8, name: 'At least 8 characters long', type: 'min' },
      { rule: /[A-Z]/, name: 'At least 1 uppercase letter', type: 'regex' },
      { rule: /[a-z]/, name: 'At least 1 lowercase letter', type: 'regex' },
      { rule: /\d/, name: 'At least 1 numeric digit', type: 'regex' },
      {
        rule: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/,
        name: 'At least 1 special character (e.g., !@#$%^&*)',
        type: 'regex',
      },
      { rule: /^\S*$/, name: 'No spaces', type: 'regex' },
    ],
    helpLink: 'https://support.finverity.com/kb/guide/en/landing-page-Z0IncfcZbi/Steps/3514119',
    isSsoAuthEnabled: true,
    locale: 'en-GB',
  },
  sentry: {
    enabled: true,
    dsn: 'https://aea0ee4f0b1b49f6b18d5d15aeda5420@o4504480764723200.ingest.sentry.io/4504519285538816',
  },
  firebase: {
    appName: 'FINVERITY',
    apiKey: 'AIzaSyAP2IlVBE8E3ItzeX6e9FkH0GH2mT9GClc',
    authDomain: 'finverity-staging.firebaseapp.com',
    databaseURL: 'https://finverity-staging.firebaseio.com',
    projectId: 'finverity-staging',
    storageBucket: 'finverity-staging.appspot.com',
    messagingSenderId: '1037880577124',
    appId: '1:1037880577124:web:3dd9469e015bef2ffe2371',
    measurementId: 'G-M90YF15270',
  },
  stonly: {
    enabled: true,
    widgetId: '848e9ac1-cbfc-11ee-bc11-06cb0cb2a85e',
  },
};
